import config from '../Config.js'

export const VersionIds = ['1.15', '1.16', '1.17', '1.18', '1.18.2', '1.19', '1.19.3', '1.19.4', '1.20', '1.20.2', '1.20.3', '1.20.5', '1.21', '1.21.2', '1.21.4', '1.21.5', '1.21.6', '1.21.9', '1.21.11', '26.1', '26.2', '26.3'] as const
export type VersionId = typeof VersionIds[number]

// ULICRAFT FORK — the ONLY Minecraft version with mirrored data.
//
// The Ulicraft server runs 1.21.1. config.json's entry for this id is
// {id: '1.21', ref: '1.21.1'}, and `ref` is what forms the mcmeta tag names
// (1.21.1-summary, 1.21.1-data, 1.21.1-atlas, 1.21.1-assets) that
// tooling/sync-generators-data.sh mirrors in ulicraft-server.
//
// Changing this means re-running that sync with a matching MC_REF FIRST.
// Pointing it at an unmirrored version yields empty registries and an infinite
// spinner, with no error explaining why. Keep it in step with VERSION /
// NEOFORGE_VERSION in ulicraft-server's docker-compose.yml.
//
// VersionSwitcher.tsx filters the UI down to this id. Note it filters the VIEW,
// not config.versions — see the comment there for why deleting version entries
// silently corrupts checkVersion().
export const MIRRORED_VERSION: VersionId = '1.21'

export const DEFAULT_VERSION: VersionId = MIRRORED_VERSION

export function checkVersion(versionId: string, minVersionId: string | undefined, maxVersionId?: string) {
	const version = config.versions.findIndex(v => v.id === versionId)
	const minVersion = minVersionId ? config.versions.findIndex(v => v.id === minVersionId) : 0
	const maxVersion = maxVersionId ? config.versions.findIndex(v => v.id === maxVersionId) : config.versions.length - 1
	return minVersion <= version && version <= maxVersion
}
